import { useEffect, useState } from "react";
import SearchBar from "../../../components/searchBar";
import { useDashboardContext } from "../../../context/dashboardContext";
import { PurchaseResponseDTO } from "../../../openapi-generated-client";
import PurchaseInfoTable from "../../../pageparts/purchaseInfoTable";

export default function DashboardPurchasesPage() {

    const {sessionId, appContext} = useDashboardContext();
    const {purchaseController} = appContext;

    const [search, setSearch] = useState("");

    const [data, setData] = useState<PurchaseResponseDTO[]>();

    async function fetchData() {
        setData((await purchaseController.getAllPurchases(sessionId)).data);
    }
    
    useEffect(() => {
        fetchData();
    }, []);

    function filterPurchases(purchases: PurchaseResponseDTO[]): PurchaseResponseDTO[] {
        return purchases.filter(current =>
            current.accountName.toLowerCase().includes(search.toLowerCase()) ||
            current.composerName.toLowerCase().includes(search.toLowerCase()) ||
            current.pieceName.toLowerCase().includes(search.toLowerCase()) ||
            current.id.toString().toLowerCase().includes(search.toLowerCase()) ||
            current.price.toString().toLowerCase().includes(search.toLowerCase())
            );
    }

    return <div className="page">
        <SearchBar search={search} onSearch={setSearch}/>
        <PurchaseInfoTable purchases={filterPurchases(data || [])} refetch={fetchData} />
    </div>;
}